import {YWPCreateAccount} from '@components/Block'

const AppleFooter = (props) => (
    <>
        <div className="applefooter text-center text-white">
            <p>The truth, is natural living and building health with nutrition and food supplements is a project. <br/> It's something you want to work at consistently.</p>
            <p className="mt-4"><strong>Like any project, you need a plan, a guide, tools, and training. <br/> Join today so you'll have all the resources you need for YOUR wellness project!</strong></p>
            <YWPCreateAccount site={props.site} bgcolor="bg-white" txtcolor="text-green"/>
        </div>
        <style jsx>{`
            .applefooter{
                background: url(../images/home/img-bottom-bg-desktop01.jpg)  no-repeat ;
                background-size:cover;
                padding: 5.4rem 1rem;
            }
            
        `}</style>
    </>
);

export default AppleFooter; 